// import React, { useEffect, useState } from 'react';
// import { onAuthStateChanged } from "firebase/auth";
// import { collection, addDoc, doc, updateDoc, deleteDoc, getDocs } from "@firebase/firestore";
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';  // Make sure axios is installed
// import { firestore, auth } from "./firebase.js";
// import TextField from '@mui/material/TextField';
// import Button from '@mui/material/Button';
// import Grid from '@mui/material/Grid';
// import Container from '@mui/material/Container';
// import FormGroup from '@mui/material/FormGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
// import Snackbar from '@mui/material/Snackbar';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
// import Paper from '@mui/material/Paper';
// import Typography from '@mui/material/Typography';
// import { Calendar, momentLocalizer } from 'react-big-calendar';
// import moment from 'moment';
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Select from '@mui/material/Select';
// import MenuItem from '@mui/material/MenuItem';
// import InputLabel from '@mui/material/InputLabel';
// import FormControl from '@mui/material/FormControl';
// import "./appointment.css";

// const localizer = momentLocalizer(moment);

// const Appointment = () => {
//     const [isAdmin, setIsAdmin] = useState(false);
//     const [userEmail, setUserEmail] = useState('');
//     const [formValues, setFormValues] = useState({
//         username: '',
//         mobno: '',
//         email: '',
//         eventName: '',
//         startTime: '',
//         endTime: '',
//         setReminder: false,
//         thankYouNotification: false,
//         visitCompleted: false,
//         hostedFor: '',
//         repetition: 'Does not repeat', // New field for repetition
//     });
//     const [events, setEvents] = useState([]);
//     const [openSnackbar, setOpenSnackbar] = useState(false);
//     const [openDialog, setOpenDialog] = useState(false);
//     const [selectedEvent, setSelectedEvent] = useState(null);
//     const [formFilled, setFormFilled] = useState(false);
//     const navigate = useNavigate();
//     const ref = collection(firestore, "appointment");

//     useEffect(() => {
//         const unsubscribe = onAuthStateChanged(auth, (user) => {
//             if (user) {
//                 const { displayName, email } = user;
//                 if ([process.env.REACT_APP_ADMIN_EMAIL1, process.env.REACT_APP_ADMIN_EMAIL2, process.env.REACT_APP_ADMIN_EMAIL3, process.env.REACT_APP_ADMIN_EMAIL4].includes(email)) {
//                     setIsAdmin(true);
//                 } else {
//                     setIsAdmin(false);
//                 }
//                 setUserEmail(email || '');
//                 setFormValues(prevValues => ({
//                     ...prevValues,
//                     username: displayName || '',
//                     email: email || '',
//                 }));
//             }
//         });

//         return () => unsubscribe();
//     }, []);

//     useEffect(() => {
//         const fetchEvents = async () => {
//             try {
//                 const snapshot = await getDocs(ref);
//                 const eventsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//                 setEvents(eventsData);
//             } catch (error) {
//                 console.error("Error fetching events: ", error);
//             }
//         };
//         fetchEvents();
//     }, []);

//     const checkFormFilled = () => {
//         const { username, mobno, email, eventName, startTime, endTime } = formValues;
//         setFormFilled(username && mobno && email && eventName && startTime && endTime);
//     };

//     const renderCalendar = () => {
//         const calendarEvents = events.map(event => ({
//             title: event.eventName,
//             start: new Date(event.startTime),
//             end: new Date(event.endTime),
//             userConfirmed: event.userConfirmed,
//         }));

//         console.log("Calendar Events:", calendarEvents);

//         return (
//             isAdmin && (
//                 <Calendar
//                     localizer={localizer}
//                     events={calendarEvents}
//                     startAccessor="start"
//                     endAccessor="end"
//                     style={{ height: 500, margin: '50px' }}
//                     selectable
//                     onSelectSlot={(slotInfo) => {
//                         setFormValues(prevValues => ({
//                             ...prevValues,
//                             startTime: moment(slotInfo.start).format('YYYY-MM-DDTHH:mm'),
//                             endTime: moment(slotInfo.end).format('YYYY-MM-DDTHH:mm'),
//                         }));
//                         setOpenDialog(true);
//                     }}
//                 />
//             )
//         );
//     };

//     const addPost = async () => {
//         try {
//             const { repetition, ...restFormValues } = formValues;

//             // Helper function to add an event
//             const addEvent = async (eventData) => {
//                 await addDoc(ref, eventData);
//                 setEvents([...events, eventData]);
//             };

//             // Helper function to adjust the date based on the repetition
//             const adjustDate = (date, repetition) => {
//                 const newDate = new Date(date);
//                 switch (repetition) {
//                     case 'Daily':
//                         newDate.setDate(newDate.getDate() + 1);
//                         break;
//                     case 'Weekly':
//                         newDate.setDate(newDate.getDate() + 7);
//                         break;
//                     case 'Monthly':
//                         newDate.setMonth(newDate.getMonth() + 1);
//                         break;
//                     default:
//                         break;
//                 }
//                 return newDate;
//             };

//             let currentStartDate = new Date(formValues.startTime);
//             let currentEndDate = new Date(formValues.endTime);
//             const repetitionLimit = 10; // Limit to prevent excessive event creation

//             for (let i = 0; i < repetitionLimit; i++) {
//                 await addEvent({
//                     ...restFormValues,
//                     startTime: currentStartDate.toISOString(),
//                     endTime: currentEndDate.toISOString(),
//                     userConfirmed: false, // Ensure userConfirmed field is initialized to false
//                 });

//                 if (repetition === 'Does not repeat') break;

//                 currentStartDate = adjustDate(currentStartDate, repetition);
//                 currentEndDate = adjustDate(currentEndDate, repetition);
//             }

//             setOpenSnackbar(true);
//             handleReset();
//         } catch (err) {
//             console.error(err);
//         }
//     };

//     const handleInputChange = (e) => {
//         const { name, value, checked, type } = e.target;
//         const newValue = type === 'checkbox' ? checked : value;
//         setFormValues(prevValues => ({
//             ...prevValues,
//             [name]: newValue
//         }));
//         checkFormFilled();
//     };

//     const handleReset = (e) => {
//         e.preventDefault();
//         setFormValues({
//             username: '',
//             mobno: '',
//             email: '',
//             eventName: '',
//             startTime: '',
//             endTime: '',
//             setReminder: false,
//             thankYouNotification: false,
//             visitCompleted: false,
//             hostedFor: '',
//             repetition: 'Does not repeat',
//         });
//         setFormFilled(false);
//     };

//     const isFormValid = () => {
//         const { eventName, startTime, endTime } = formValues;
//         return eventName && startTime && endTime;
//     };

//     const handleSnackbarClose = () => {
//         setOpenSnackbar(false);
//     };

//     // Email sending functions
//     const sendOrderErrorEmail = async (email, apiKey, orderId, errorMessage) => {
//         const jsonPayload = {
//             email,
//             subject: `Order Confirmation Error - ${orderId}`,
//             textbody: `We encountered an error while processing your order with ID ${orderId}.`,
//             htmlbody: 
//                 `<div style="font-family: Arial, sans-serif; color: #333;">
//                     <h2 style="color: #f44336;">Order Confirmation Error</h2>
//                     <p>We encountered an error while processing your order with ID <strong>${orderId}</strong>.</p>
//                     <p>Error Details: ${errorMessage}</p>
//                     <p>Please contact our support team for assistance.</p>
//                 </div>`,
//             apiKey,
//         };

//         const formData = new FormData();
//         formData.append('jsonPayload', JSON.stringify(jsonPayload));

//         try {
//             const response = await axios.post('https://email-a306.onrender.com/send-email', formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 },
//             });

//             if (response.status === 200) {
//                 return 'Error email sent successfully!';
//             } else {
//                 return 'Error sending error email.';
//             }
//         } catch (error) {
//             if (error.response && error.response.status === 403) {
//                 return 'Invalid API key';
//             } else {
//                 return 'Error sending error email.';
//             }
//         }
//     };


//     const sendOrderConfirmationEmail = async (email, apiKey, orderId, eventName, eventDate, eventTime) => {
//         const jsonPayload = {
//             email,
//             subject: `Order Confirmation - ${orderId}`,
//             textbody: `Thank you for your order. Your order ID is ${orderId}.`,
//             htmlbody: 
//                 `<div style="font-family: Arial, sans-serif; color: #333;">
//                     <h2 style="color: #4CAF50;">Thank you for your order!</h2>
//                     <p>Your order ID is <strong>${orderId}</strong>.</p>
//                     <h3>Event Details:</h3>
//                     <p><strong>Event Name:</strong> ${eventName}</p>
//                     <p><strong>Date:</strong> ${eventDate}</p>
//                     <p><strong>Time:</strong> ${eventTime}</p>
//                 </div>`,
//             apiKey,
//         };
    
//         const formData = new FormData();
//         formData.append('jsonPayload', JSON.stringify(jsonPayload));
    
//         try {
//             const response = await axios.post('https://email-a306.onrender.com/send-email', formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 },
//             });
    
//             if (response.status === 200) {
//                 return 'Email sent successfully!';
//             } else {
//                 await sendOrderErrorEmail(email, apiKey, orderId, 'Error sending confirmation email');
//                 return 'Error sending email.';
//             }
//         } catch (error) {
//             if (error.response && error.response.status === 403) {
//                 await sendOrderErrorEmail(email, apiKey, orderId, 'Invalid API key');
//                 return 'Invalid API key';
//             } else {
//                 await sendOrderErrorEmail(email, apiKey, orderId, 'Error sending confirmation email');
//                 return 'Error sending email.';
//             }
//         }
//     };
    
//     const confirmAppointment = async (appointmentId) => {
//         try {
//             const appointmentRef = doc(firestore, "appointment", appointmentId);
//             await updateDoc(appointmentRef, { userConfirmed: true });
    
//             const event = events.find(event => event.id === appointmentId);
//             const email = event.email;
//             const apiKey = 'qwertyuiop'; // Replace with your actual API key
//             const orderId = appointmentId;
//             const eventName = event.eventName;
//             const eventDate = moment(event.startTime).format('YYYY-MM-DD');
//             const eventTime = moment(event.startTime).format('HH:mm');
    
//             await sendOrderConfirmationEmail(email, apiKey, orderId, eventName, eventDate, eventTime);
    
//             setEvents(events.map(event => event.id === appointmentId ? { ...event, userConfirmed: true } : event));
//         } catch (error) {
//             console.error("Error confirming appointment: ", error);
//         }
//     };
    

//     return (
//         <Container>
//             <form>
//                 <Grid container spacing={3}>
//                     <Grid item xs={12} sm={6}>
//                         <TextField
//                             required
//                             id="username"
//                             name="username"
//                             label="Username"
//                             fullWidth
//                             value={formValues.username}
//                             onChange={handleInputChange}
//                         />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                         <TextField
//                             required
//                             id="mobno"
//                             name="mobno"
//                             label="Mobile Number"
//                             fullWidth
//                             value={formValues.mobno}
//                             onChange={handleInputChange}
//                         />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                         <TextField
//                             required
//                             id="email"
//                             name="email"
//                             label="Email"
//                             fullWidth
//                             value={formValues.email}
//                             onChange={handleInputChange}
//                         />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                         <TextField
//                             required
//                             id="eventName"
//                             name="eventName"
//                             label="Event Name"
//                             fullWidth
//                             value={formValues.eventName}
//                             onChange={handleInputChange}
//                         />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                         <TextField
//                             required
//                             id="startTime"
//                             name="startTime"
//                             label="Start Time"
//                             type="datetime-local"
//                             fullWidth
//                             InputLabelProps={{
//                                 shrink: true,
//                             }}
//                             value={formValues.startTime}
//                             onChange={handleInputChange}
//                         />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                         <TextField
//                             required
//                             id="endTime"
//                             name="endTime"
//                             label="End Time"
//                             type="datetime-local"
//                             fullWidth
//                             InputLabelProps={{
//                                 shrink: true,
//                             }}
//                             value={formValues.endTime}
//                             onChange={handleInputChange}
//                         />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                         <FormControl fullWidth>
//                             <InputLabel id="repetition-label">Repetition</InputLabel>
//                             <Select
//                                 labelId="repetition-label"
//                                 id="repetition"
//                                 name="repetition"
//                                 value={formValues.repetition}
//                                 onChange={handleInputChange}
//                             >
//                                 <MenuItem value="Does not repeat">Does not repeat</MenuItem>
//                                 <MenuItem value="Daily">Daily</MenuItem>
//                                 <MenuItem value="Weekly">Weekly</MenuItem>
//                                 <MenuItem value="Monthly">Monthly</MenuItem>
//                             </Select>
//                         </FormControl>
//                     </Grid>
//                     {isAdmin && (
//                         <>
//                             <Grid item xs={12}>
//                                 <FormGroup>
//                                     <FormControlLabel
//                                         control={
//                                             <Checkbox
//                                                 checked={formValues.setReminder}
//                                                 onChange={handleInputChange}
//                                                 name="setReminder"
//                                                 color="primary"
//                                             />
//                                         }
//                                         label="Set Reminder"
//                                     />
//                                     <FormControlLabel
//                                         control={
//                                             <Checkbox
//                                                 checked={formValues.thankYouNotification}
//                                                 onChange={handleInputChange}
//                                                 name="thankYouNotification"
//                                                 color="primary"
//                                             />
//                                         }
//                                         label="Thank You Notification"
//                                     />
//                                     <FormControlLabel
//                                         control={
//                                             <Checkbox
//                                                 checked={formValues.visitCompleted}
//                                                 onChange={handleInputChange}
//                                                 name="visitCompleted"
//                                                 color="primary"
//                                             />
//                                         }
//                                         label="Visit Completed"
//                                     />
//                                 </FormGroup>
//                             </Grid>
//                             <Grid item xs={12}>
//                                 <TextField
//                                     required
//                                     id="hostedFor"
//                                     name="hostedFor"
//                                     label="Hosted For"
//                                     fullWidth
//                                     value={formValues.hostedFor}
//                                     onChange={handleInputChange}
//                                 />
//                             </Grid>
//                         </>
//                     )}
//                     <Grid item xs={12}>
//                         <Button
//                             variant="contained"
//                             color="primary"
//                             onClick={addPost}
//                             disabled={!isFormValid()}
//                         >
//                             Add Appointment
//                         </Button>
//                     </Grid>
//                 </Grid>
//             </form>
//             <Snackbar
//                 open={openSnackbar}
//                 autoHideDuration={6000}
//                 onClose={handleSnackbarClose}
//                 message="Appointment added successfully"
//             />
//             <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
//                 <DialogTitle>Add Event</DialogTitle>
//                 <DialogContent>
//                     <DialogContentText>
//                         Do you want to add this event?
//                     </DialogContentText>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={() => setOpenDialog(false)} color="primary">
//                         Cancel
//                     </Button>
//                     <Button onClick={addPost} color="primary">
//                         Add
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//             {renderCalendar()}
//             {isAdmin && (
//                 <TableContainer component={Paper}>
//                     <Table>
//                         <TableHead>
//                             <TableRow>
//                                 <TableCell>Username</TableCell>
//                                 <TableCell>Event Name</TableCell>
//                                 <TableCell>Start Time</TableCell>
//                                 <TableCell>End Time</TableCell>
//                                 <TableCell>Confirmed</TableCell>
//                                 <TableCell>Action</TableCell>
//                             </TableRow>
//                         </TableHead>
//                         <TableBody>
//                             {events.map((event) => (
//                                 <TableRow key={event.id}>
//                                     <TableCell>{event.username}</TableCell>
//                                     <TableCell>{event.eventName}</TableCell>
//                                     <TableCell>{new Date(event.startTime).toLocaleString()}</TableCell>
//                                     <TableCell>{new Date(event.endTime).toLocaleString()}</TableCell>
//                                     <TableCell>{event.userConfirmed ? "Yes" : "No"}</TableCell>
//                                     <TableCell>
//                                         <Button
//                                             variant="contained"
//                                             color="primary"
//                                             onClick={() => confirmAppointment(event.id)}
//                                             disabled={event.userConfirmed}
//                                         >
//                                             Confirm
//                                         </Button>
//                                     </TableCell>
//                                 </TableRow>
//                             ))}
//                         </TableBody>
//                     </Table>
//                 </TableContainer>
//             )}
//         </Container>
//     );
// }

// export default Appointment;









// import React, { useState } from 'react';
// import TextField from '@mui/material/TextField';
// import Button from '@mui/material/Button';

// import Container from '@mui/material/Container';

// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';

// import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
// import { getFirestore, doc, setDoc } from 'firebase/firestore';
// import { initializeApp } from 'firebase/app';
// import { firebaseConfig } from './firebase'; // Ensure firebaseConfig is correctly exported

// const app = initializeApp(firebaseConfig);
// const storage = getStorage(app);
// const db = getFirestore(app);

// const Appointment = () => {
//     const [openDialog, setOpenDialog] = useState(false);
//     const [formValues, setFormValues] = useState({
//         startTime: '',
//         endTime: '',
//         image: null,
//         imageUrl: ''
//     });

//     const handleInputChange = (e) => {
//         const { name, value, files } = e.target;
//         setFormValues(prev => ({
//             ...prev,
//             [name]: files ? files[0] : value
//         }));
//     };

//     const addPost = async () => {
//         try {
//             if (!formValues.image) {
//                 alert('Please select an image.');
//                 return;
//             }

//             const imageRef = ref(storage, `flyers/${formValues.image.name}`);
//             await uploadBytes(imageRef, formValues.image);
//             const imageUrl = await getDownloadURL(imageRef);

//             // Store the event details in Firestore
//             const eventRef = doc(db, 'events', new Date().toISOString());
//             await setDoc(eventRef, {
//                 startTime: formValues.startTime,
//                 endTime: formValues.endTime,
//                 imageUrl: imageUrl,
//             });

//             setFormValues({
//                 startTime: '',
//                 endTime: '',
//                 image: null,
//                 imageUrl: ''
//             });
//             setOpenDialog(false);
//             alert('Event created successfully!');
//         } catch (error) {
//             console.error('Error uploading image or saving data:', error);
//             alert('Failed to create event. Please try again.');
//         }
//     };

//     return (
//         <Container>
//             <Button variant="contained" color="primary" onClick={() => setOpenDialog(true)}>
//                 Create Event
//             </Button>
//             <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
//                 <DialogTitle>Create Event</DialogTitle>
//                 <DialogContent>
//                     <DialogContentText>
//                         Fill in the details for the event and upload an image.
//                     </DialogContentText>
//                     <TextField
//                         margin="dense"
//                         label="Start Time"
//                         type="datetime-local"
//                         fullWidth
//                         name="startTime"
//                         value={formValues.startTime}
//                         onChange={handleInputChange}
//                         InputLabelProps={{ shrink: true }}
//                     />
//                     <TextField
//                         margin="dense"
//                         label="End Time"
//                         type="datetime-local"
//                         fullWidth
//                         name="endTime"
//                         value={formValues.endTime}
//                         onChange={handleInputChange}
//                         InputLabelProps={{ shrink: true }}
//                     />
//                     <TextField
//                         margin="dense"
//                         label="Image"
//                         type="file"
//                         fullWidth
//                         name="image"
//                         onChange={handleInputChange}
//                     />
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={() => setOpenDialog(false)} color="primary">
//                         Cancel
//                     </Button>
//                     <Button onClick={addPost} color="primary">
//                         Create
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//         </Container>
//     );
// };

// export default Appointment;

// import React, { useEffect, useState } from 'react';
// import { onAuthStateChanged } from "firebase/auth";
// import { collection, addDoc, doc, updateDoc, deleteDoc, getDocs } from "@firebase/firestore";
// import { useNavigate } from 'react-router-dom';
// import { firestore, auth } from "./firebase.js";
// import TextField from '@mui/material/TextField';
// import Button from '@mui/material/Button';
// import Grid from '@mui/material/Grid';
// import Container from '@mui/material/Container';
// import FormGroup from '@mui/material/FormGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
// import Snackbar from '@mui/material/Snackbar';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
// import Paper from '@mui/material/Paper';
// import Typography from '@mui/material/Typography';
// import { Calendar, momentLocalizer } from 'react-big-calendar';
// import moment from 'moment';
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Select from '@mui/material/Select';
// import MenuItem from '@mui/material/MenuItem';
// import InputLabel from '@mui/material/InputLabel';
// import FormControl from '@mui/material/FormControl';
// import "./appointment.css";
// // import useStyles from './styles'; // Import the styles

// import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
// import { getFirestore,  setDoc } from 'firebase/firestore';
// import { initializeApp } from 'firebase/app';
// import { firebaseConfig } from './firebase'; // Ensure firebaseConfig is correctly exported

// const app = initializeApp(firebaseConfig);
// const storage = getStorage(app);
// const db = getFirestore(app);

// const localizer = momentLocalizer(moment);

// const Appointment = () => {
//     const [isAdmin, setIsAdmin] = useState(false);
//     const [userEmail, setUserEmail] = useState('');
//     const [formValues, setFormValues] = useState({
//         username: '',
//         mobno: '',
//         email: '',
//         eventName: '',
//         startTime: '',
//         endTime: '',
//         setReminder: false,
//         thankYouNotification: false,
//         visitCompleted: false,
//         hostedFor: '',
//         repetition: 'Does not repeat', // New field for repetition
//     });
//     const [events, setEvents] = useState([]);
//     const [openSnackbar, setOpenSnackbar] = useState(false);
//     const [openEditDialog, setOpenEditDialog] = useState(false); // Added state for Edit Dialog
//     const [openDialog, setOpenDialog] = useState(false);
//     const [newEventName, setNewEventName] = useState(''); // Added state for new event name
//     const [selectedEvent, setSelectedEvent] = useState(null);
//     const [formFilled, setFormFilled] = useState(false);
//     const navigate = useNavigate();
//     const ref = collection(firestore, "appointment");

//     useEffect(() => {
//         const unsubscribe = onAuthStateChanged(auth, (user) => {
//             if (user) {
//                 const { displayName, email } = user;
//                 if ([process.env.REACT_APP_ADMIN_EMAIL1, process.env.REACT_APP_ADMIN_EMAIL2, process.env.REACT_APP_ADMIN_EMAIL3, process.env.REACT_APP_ADMIN_EMAIL4].includes(email)) {
//                     setIsAdmin(true);
//                 } else {
//                     setIsAdmin(false);
//                 }
//                 setUserEmail(email || '');
//                 setFormValues(prevValues => ({
//                     ...prevValues,
//                     username: displayName || '',
//                     email: email || '',
//                 }));
//             }
//         });

//         return () => unsubscribe();
//     }, []);

//     useEffect(() => {
//         const fetchEvents = async () => {
//             try {
//                 const snapshot = await getDocs(ref);
//                 const eventsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//                 setEvents(eventsData);
//             } catch (error) {
//                 console.error("Error fetching events: ", error);
//             }
//         };
//         fetchEvents();
//     }, []);

//     const checkFormFilled = () => {
//         const { username, mobno, email, eventName, startTime, endTime } = formValues;
//         setFormFilled(username && mobno && email && eventName && startTime && endTime);
//     };

//     const renderCalendar = () => {
//         const calendarEvents = events.map(event => ({
//             title: event.eventName,
//             start: new Date(event.startTime),
//             end: new Date(event.endTime),
//             userConfirmed: event.userConfirmed,
//         }));

//         console.log("Calendar Events:", calendarEvents);

//         return (
//             isAdmin && (
//                 <Calendar
//                     localizer={localizer}
//                     events={calendarEvents}
//                     startAccessor="start"
//                     endAccessor="end"
//                     style={{ height: 500, margin: '50px' }}
//                     selectable
//                     onSelectSlot={(slotInfo) => {
//                         setFormValues(prevValues => ({
//                             ...prevValues,
//                             startTime: moment(slotInfo.start).format('YYYY-MM-DDTHH:mm'),
//                             endTime: moment(slotInfo.end).format('YYYY-MM-DDTHH:mm'),
//                         }));
//                         setOpenDialog(true);
//                     }}
//                 />
//             )
//         );
//     };

//     const addPost = async () => {
//         try {
//             const { repetition, ...restFormValues } = formValues;
//             const userConfirmed = !isAdmin;
    
//             // Helper function to add an event
//             const addEvent = async (eventData) => {
//                 const newEvent = {
//                     ...eventData,
//                     userConfirmed,
//                     confirmed: isAdmin, // Admin confirmation status
//                 };
//                 await addDoc(ref, newEvent);
//                 setEvents([...events, newEvent]);
//             };
    
//             // Helper function to adjust the date based on the repetition
//             const adjustDate = (date, repetition) => {
//                 const newDate = new Date(date);
//                 switch (repetition) {
//                     case 'Daily':
//                         newDate.setDate(newDate.getDate() + 1);
//                         break;
//                     case 'Weekly':
//                         newDate.setDate(newDate.getDate() + 7);
//                         break;
//                     case 'Monthly':
//                         newDate.setMonth(newDate.getMonth() + 1);
//                         break;
//                     default:
//                         break;
//                 }
//                 return newDate;
//             };
    
//             let currentStartDate = new Date(formValues.startTime);
//             let currentEndDate = new Date(formValues.endTime);
//             const repetitionLimit = 10; // Limit to prevent excessive event creation
    
//             for (let i = 0; i < repetitionLimit; i++) {
//                 await addEvent({
//                     ...restFormValues,
//                     startTime: currentStartDate.toISOString(),
//                     endTime: currentEndDate.toISOString(),
//                 });
    
//                 if (repetition === 'Does not repeat') break;
    
//                 currentStartDate = adjustDate(currentStartDate, repetition);
//                 currentEndDate = adjustDate(currentEndDate, repetition);
//             }
    
//             setOpenSnackbar(true);
//             handleReset();
//         } catch (err) {
//             console.error(err);
//         }
//     };

//     const handleInputChange = (e) => {
//         const { name, value, checked, type } = e.target;
//         const newValue = type === 'checkbox' ? checked : value;
//         setFormValues(prevValues => ({
//             ...prevValues,
//             [name]: newValue
//         }));
//         checkFormFilled();
//     };

//     const handleReset = (e) => {
//         e.preventDefault();
//         setFormValues({
//             username: '',
//             mobno: '',
//             email: '',
//             eventName: '',
//             startTime: '',
//             endTime: '',
//             setReminder: false,
//             thankYouNotification: false,
//             visitCompleted: false,
//             hostedFor: '',
//             repetition: 'Does not repeat',
//         });
//         setFormFilled(false);
//     };

//     const isFormValid = () => {
//         const { eventName, startTime, endTime } = formValues;
//         return eventName && startTime && endTime;
//     };

//     const handleSnackbarClose = () => {
//         setOpenSnackbar(false);
//     };


//     const confirmAppointment = async (eventId) => {
//         try {
//             const eventDoc = doc(firestore, "appointment", eventId);
//             await updateDoc(eventDoc, { confirmed: true });
//             setEvents(events.map(event => event.id === eventId ? { ...event, confirmed: true } : event));
//         } catch (error) {
//             console.error("Error confirming appointment: ", error);
//         }
//     };

//     const rejectAppointment = async (eventId) => {
//         try {
//             const eventDoc = doc(firestore, "appointment", eventId);
//             await deleteDoc(eventDoc);
//             setEvents(events.filter(event => event.id !== eventId));
//         } catch (error) {
//             console.error("Error deleting appointment: ", error);
//         }
//     };

//     const handleRowClick = (event) => {
//         setSelectedEvent(event);
//     };

//     const handleEditClick = (event) => {
//         setSelectedEvent(event);
//         setNewEventName(event.eventName);
//         setOpenEditDialog(true);
//     };

//     const handleUpdateEventName = async () => {
//         if (selectedEvent) {
//             const eventDoc = doc(firestore, "appointment", selectedEvent.id);
//             try {
//                 await updateDoc(eventDoc, { eventName: newEventName });
//                 setEvents(events.map(event => event.id === selectedEvent.id ? { ...event, eventName: newEventName } : event));
//                 setOpenEditDialog(false);
//             } catch (error) {
//                 console.error("Error updating event name: ", error);
//             }
//         }
//     };


//     const renderAdminControls = () => (
//         <TableContainer component={Paper}>
//             <Table>
//                 <TableHead>
//                     <TableRow>
//                         <TableCell>Customer</TableCell>
//                         <TableCell>Mobile</TableCell>
//                         <TableCell>Email</TableCell>
//                         <TableCell>Event Name</TableCell>
//                         <TableCell>Start Time</TableCell>
//                         <TableCell>End Time</TableCell>
//                         <TableCell>Hosted For</TableCell>
//                         <TableCell>User Confirmation</TableCell>
//                         <TableCell>Actions</TableCell>
//                     </TableRow>
//                 </TableHead>
//                 <TableBody>
//                     {events.map(event => (
//                         <TableRow key={event.id}>
//                             <TableCell>{event.username}</TableCell>
//                             <TableCell>{event.mobno}</TableCell>
//                             <TableCell>{event.email}</TableCell>
//                             <TableCell>{event.eventName}</TableCell>
//                             <TableCell>{moment(event.startTime).format('MMMM Do YYYY, h:mm a')}</TableCell>
//                             <TableCell>{moment(event.endTime).format('MMMM Do YYYY, h:mm a')}</TableCell>
//                             <TableCell>{event.hostedFor}</TableCell>
//                             <TableCell>{event.userConfirmed ? 'Confirmed' : 'Pending'}</TableCell>
//                             <TableCell>
//                                 <Button variant="contained" color="primary" onClick={() => confirmAppointment(event.id)} disabled={event.confirmed}>Confirm </Button>
//                                 <Button variant="contained" color="secondary" onClick={() => rejectAppointment(event.id)}>Reject</Button>
//                                 <Button variant="contained" onClick={() => handleEditClick(event)}>Edit</Button>
//                             </TableCell>
//                         </TableRow>
//                     ))}
//                 </TableBody>
//             </Table>
//         </TableContainer>
//     );

//     const renderUserControls = () => {
//         return (
//             <TableContainer component={Paper}>
//                 <Table>
//                     <TableHead>
//                         <TableRow>
//                             <TableCell>Customer</TableCell>
//                             <TableCell>Mobile</TableCell>
//                             <TableCell>Email</TableCell>
//                             <TableCell>Event Name</TableCell>
//                             <TableCell>Start Time</TableCell>
//                             <TableCell>End Time</TableCell>
//                             <TableCell>Admin Confirmation Status</TableCell> {/* New column */}
//                             <TableCell>Actions</TableCell>
//                         </TableRow>
//                     </TableHead>
//                     <TableBody>
//                         {events.map(event => (
//                             <TableRow key={event.id} onClick={() => handleRowClick(event)} selected={selectedEvent && selectedEvent.id === event.id}>
//                                 <TableCell>{event.username}</TableCell>
//                                 <TableCell>{event.mobno}</TableCell>
//                                 <TableCell>{event.hostedFor || event.email}</TableCell>
//                                 <TableCell>{event.eventName}</TableCell>
//                                 <TableCell>{moment(event.startTime).format('MMMM Do YYYY, h:mm a')}</TableCell>
//                                 <TableCell>{moment(event.endTime).format('MMMM Do YYYY, h:mm a')}</TableCell>
//                                 <TableCell>
//                                     {event.confirmed ? 'Confirmed' : 'Pending'} {/* Admin confirmation status */}
//                                 </TableCell>
//                                 <TableCell>
//                                     {(!isAdmin && event.hostedFor === userEmail) ? (
//                                         <>
//                                             <Button
//                                                 variant="contained"
//                                                 color="primary"
//                                                 onClick={() => confirmUserAppointment(event.id)}
//                                                 style={{ marginRight: '10px' }}
//                                                 disabled={event.userConfirmed}
//                                             >
//                                                 Confirm
//                                             </Button>
//                                             <Button
//                                                 variant="contained"
//                                                 color="secondary"
//                                                 onClick={() => rejectUserAppointment(event.id)}
//                                             >
//                                                 Reject
//                                             </Button>
//                                         </>
//                                     ) : (!isAdmin && !event.userConfirmed) ? (
//                                         <Button
//                                             variant="contained"
//                                             color="secondary"
//                                             onClick={() => rejectUserAppointment(event.id)}
//                                         >
//                                             Reject
//                                         </Button>
//                                     ) : (!isAdmin && event.userConfirmed) ? (  // Allow user to reject after confirming
//                                         <Button
//                                             variant="contained"
//                                             color="secondary"
//                                             onClick={() => rejectUserAppointment(event.id)}
//                                         >
//                                             Reject
//                                         </Button>
//                                     ) : null}
//                                 </TableCell>
//                             </TableRow>
//                         ))}
//                     </TableBody>
//                 </Table>
//             </TableContainer>
//         );
//     };


    

 
//     const confirmUserAppointment = async (eventId) => {
//         try {
//             const eventDoc = doc(firestore, "appointment", eventId);
//             await updateDoc(eventDoc, { userConfirmed: true });
//             setEvents(events.map(event => 
//                 event.id === eventId 
//                 ? { ...event, userConfirmed: true } 
//                 : event
//             ));
//         } catch (error) {
//             console.error("Error confirming appointment: ", error);
//         }
//     };
    
//     const rejectUserAppointment = async (eventId) => {
//         try {
//             const eventDoc = doc(firestore, "appointment", eventId);
//             await deleteDoc(eventDoc);  // Delete the document from Firestore
//             setEvents(events.filter(event => event.id !== eventId));  // Update the local state to remove the event
//         } catch (error) {
//             console.error("Error rejecting appointment: ", error);
//         }
//     };



//     const [openDDialog, setOOpenDialog] = useState(false);
//     const [formVValues, setFFormValues] = useState({
//         startTime: '',
//         endTime: '',
//         image: null,
//         imageUrl: ''
//     });

//     const handleIInputChange = (e) => {
//         const { name, value, files } = e.target;
//         setFFormValues(prev => ({
//             ...prev,
//             [name]: files ? files[0] : value
//         }));
//     };

//     const add1Post = async () => {
//         try {
//             if (!formVValues.image) {
//                 alert('Please select an image.');
//                 return;
//             }

//             const imageRef = ref(storage, `flyers/${formValues.image.name}`);
//             await uploadBytes(imageRef, formVValues.image);
//             const imageUrl = await getDownloadURL(imageRef);

//             // Store the event details in Firestore
//             const eventRef = doc(db, 'events', new Date().toISOString());
//             await setDoc(eventRef, {
//                 startTime: formVValues.startTime,
//                 endTime: formVValues.endTime,
//                 imageUrl: imageUrl,
//             });

//             setFFormValues({
//                 startTime: '',
//                 endTime: '',
//                 image: null,
//                 imageUrl: ''
//             });
//             setOOpenDialog(false);
//             alert('Event created successfully!');
//         } catch (error) {
//             console.error('Error uploading image or saving data:', error);
//             alert('Failed to create event. Please try again.');
//         }
//     };
//     return (
//         <Container maxWidth="md">
//             <Button variant="contained" color="primary" onClick={() => setOpenDialog(true)}>
//     Create Event
// </Button>
// <Dialog open={openDDialog} onClose={() => setOOpenDialog(false)}>
//     <DialogTitle>Create Event</DialogTitle>
//     <DialogContent>
//         <DialogContentText>
//             Fill in the details for the event and upload an image.
//         </DialogContentText>
//         <TextField
//             margin="dense"
//             label="Start Time"
//             type="datetime-local"
//             fullWidth
//             name="startTime"
//             value={formVValues.startTime}
//             onChange={handleIInputChange}
//             InputLabelProps={{ shrink: true }}
//         />
//         <TextField
//             margin="dense"
//             label="End Time"
//             type="datetime-local"
//             fullWidth
//             name="endTime"
//             value={formVValues.endTime}
//             onChange={handleIInputChange}
//             InputLabelProps={{ shrink: true }}
//         />
//         <TextField
//             margin="dense"
//             label="Image"
//             type="file"
//             fullWidth
//             name="image"
//             onChange={handleIInputChange}
//         />
//     </DialogContent>
//     <DialogActions>
//         <Button onClick={() => setOOpenDialog(false)} color="primary">
//             Cancel
//         </Button>
//         <Button onClick={add1Post} color="primary">
//             Create
//         </Button>
//     </DialogActions>
// </Dialog>

//             <form onSubmit={(e) => { e.preventDefault(); addPost(); }}>
//                 <Grid container spacing={3}>
//                     <Grid item xs={12}>
//                         <TextField
//                             required
//                             label="Username"
//                             name="username"
//                             value={formValues.username}
//                             onChange={handleInputChange}
//                             fullWidth
//                             variant="outlined"
//                         />
//                     </Grid>
//                     <Grid item xs={12}>
//                         <TextField
//                             required
//                             label="Mobile Number"
//                             name="mobno"
//                             value={formValues.mobno}
//                             onChange={handleInputChange}
//                             fullWidth
//                             variant="outlined"
//                         />
//                     </Grid>
//                     <Grid item xs={12}>
//                         <TextField
//                             required
//                             label="Email"
//                             name="email"
//                             value={formValues.email}
//                             onChange={handleInputChange}
//                             fullWidth
//                             variant="outlined"
//                         />
//                     </Grid>
//                     <Grid item xs={12}>
//                         <TextField
//                             required
//                             label="Event Name"
//                             name="eventName"
//                             value={formValues.eventName}
//                             onChange={handleInputChange}
//                             fullWidth
//                             variant="outlined"
//                         />
//                     </Grid>
//                     <Grid item xs={12}>
//                         <TextField
//                             required
//                             label="Start Time"
//                             name="startTime"
//                             type="datetime-local"
//                             value={formValues.startTime}
//                             onChange={handleInputChange}
//                             variant="outlined"
//                             InputLabelProps={{
//                                 shrink: true,
//                             }}
//                             fullWidth
//                         />
//                     </Grid>
//                     <Grid item xs={12}>
//                         <TextField
//                             required
//                             label="End Time"
//                             name="endTime"
//                             type="datetime-local"
//                             value={formValues.endTime}
//                             onChange={handleInputChange}
//                             InputLabelProps={{
//                                 shrink: true,
//                             }}
//                             fullWidth
//                         />
//                     </Grid>
//                     <Grid item xs={12}>
//                         <TextField
//                             label="Hosted For"
//                             name="hostedFor"
//                             value={formValues.hostedFor}
//                             onChange={handleInputChange}
//                             fullWidth
//                         />
//                     </Grid>
//                     <Grid item xs={12}>
//                         <Select
//                             name="repetition"
//                             value={formValues.repetition}
//                             onChange={handleInputChange}
//                             fullWidth
//                         >
//                             <MenuItem value="Does not repeat">Does not repeat</MenuItem>
//                             <MenuItem value="Daily">Daily</MenuItem>
//                             <MenuItem value="Weekly">Weekly</MenuItem>
//                             <MenuItem value="Monthly">Monthly</MenuItem>
//                         </Select>
//                     </Grid>
//                     <Grid item xs={12}>
//                         {isAdmin &&(<FormGroup>
//                             <FormControlLabel
//                                 control={<Checkbox checked={formValues.setReminder} onChange={handleInputChange} name="setReminder" />}
//                                 label="Set Reminder"
//                             />
//                             <FormControlLabel
//                                 control={<Checkbox checked={formValues.thankYouNotification} onChange={handleInputChange} name="thankYouNotification" />}
//                                 label="Thank You Notification"
//                             />
//                             <FormControlLabel
//                                 control={<Checkbox checked={formValues.visitCompleted} onChange={handleInputChange} name="visitCompleted" />}
//                                 label="Visit Completed"
//                             />
//                         </FormGroup>)}
//                     </Grid>
//                     <Grid item xs={12}>
//                         <Button type="submit" variant="contained" color="primary" disabled={!isFormValid()}>
//                             Submit
//                         </Button>
//                         <Button variant="contained" onClick={handleReset}>
//                             Reset
//                         </Button>
//                     </Grid>
//                 </Grid>
//             </form>
//             <Snackbar
//                 open={openSnackbar}
//                 autoHideDuration={6000}
//                 onClose={handleSnackbarClose}
//                 message="Appointment added successfully"
//             />
            
//             {isAdmin && renderCalendar()}
//             {isAdmin ? renderAdminControls() : renderUserControls()}
            
//             <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)}>
//             <DialogTitle>Edit Event Name</DialogTitle>
//             <DialogContent>
//                 <DialogContentText>
//                     Update the name of the event.
//                 </DialogContentText>
//                 <TextField
//                     autoFocus
//                     margin="dense"
//                     label="Event Name"
//                     type="text"
//                     fullWidth
//                     value={newEventName}
//                     onChange={(e) => setNewEventName(e.target.value)}
//                 />
//             </DialogContent>
//             <DialogActions>
//                 <Button onClick={() => setOpenEditDialog(false)} color="primary">Cancel</Button>
//                 <Button onClick={handleUpdateEventName} color="primary">Update</Button>
//             </DialogActions>
//         </Dialog>

        
//         </Container>
//     );

// };

// export default Appointment;

import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from "firebase/auth";
import { collection, addDoc, doc, updateDoc, deleteDoc, getDocs } from "@firebase/firestore";
import { useNavigate } from 'react-router-dom';
import { firestore, auth } from "./firebase.config";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Snackbar from '@mui/material/Snackbar';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
// import { makeStyles } from '@mui/styles';
// import { styled } from '@mui/material/styles';
import "./appointment.css";
import axios from 'axios';
// import useStyles from './styles'; 

// const StyledTextField = styled(TextField)(({ theme }) => ({
//   marginTop: '0px',
// }));

const localizer = momentLocalizer(moment);
// const useStyles = makeStyles(() => ({
//   formControl: {
//     marginBottom: 16,
//     minWidth: 120,
//   },
//   textField: {
//     '& .MuiOutlinedInput-root': {
//       '& fieldset': {
//         borderColor: '#ccc',
//       },
//       '&:hover fieldset': {
//         borderColor: '#888',
//       },
//       '&.Mui-focused fieldset': {
//         borderColor: '#3f51b5',
//       },
//       '& .MuiOutlinedInput-notchedOutline': {
//         borderWidth: '1px',
//       },
//     },
//     '& .MuiInputLabel-root': {
//       transform: 'translate(14px, 14px) scale(1)',
//       '&.MuiInputLabel-shrink': {
//         transform: 'translate(14px, -6px) scale(0.75)',
//       },
//     },
//   },
//   selectField: {
//     '& .MuiOutlinedInput-root': {
//       '& fieldset': {
//         borderColor: '#ccc',
//       },
//       '&:hover fieldset': {
//         borderColor: '#888',
//       },
//       '&.Mui-focused fieldset': {
//         borderColor: '#3f51b5',
//       },
//     },
//   },
// }));

const Appointment = ({ isAdmin,email }) => {
    // const classes = useStyles();
    // const [isAdmin, setIsAdmin] = useState(false);
    console.log(email);
    const [userEmail, setUserEmail] = useState(email || '');
    const [formValues, setFormValues] = useState({
        username: '',
        mobno: '',
        email: '',
        eventName: '',
        startTime: '',
        endTime: '',
        setReminder: false,
        thankYouNotification: false,
        visitCompleted: false,
        hostedFor: '',
        repetition: 'Does not repeat', // New field for repetition
    });
    const [events, setEvents] = useState([]);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [openEditDialog, setOpenEditDialog] = useState(false); // Added state for Edit Dialog
    const [openDialog, setOpenDialog] = useState(false);
    const [newEventName, setNewEventName] = useState(''); // Added state for new event name
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [formFilled, setFormFilled] = useState(false);
    const navigate = useNavigate();
    const ref = collection(firestore, "appointment");

    // useEffect(() => {
    //     const unsubscribe = onAuthStateChanged(auth, (user) => {
    //         if (user) {
    //             const { displayName, email } = user;
    //             setUserEmail(email || '');
    //             setFormValues(prevValues => ({
    //                 ...prevValues,
    //                 username: displayName || '',
    //                 email: email || '',
    //             }));
    //         }
    //     });

        // const verifyToken = async () => {
        //     const token = sessionStorage.getItem('jwtToken'); // Get token from session storage
        //     console.log("Retrieved JWT Token from session storage:", token);

        //     if (!token) {
        //         console.log("No JWT token found in session storage.");
        //         return;
        //     }

        //     try {
        //         // Call the API to verify the token
        //         const response = await fetch(`${process.env.REACT_APP_DECODE_TOKEN_API_URL}`, {
        //             method: 'GET',
        //             headers: {
        //                 Authorization: `Bearer ${token}`,
        //             },
        //         });
        //         console.log("API Response Status:", response.status);

        //         const data = await response.json();
        //         console.log("API Response Data:", data);

        //         if (response.ok && data.role === 'Admin') {
        //             setIsAdmin(true);
        //             console.log("User is Admin, setting isAdmin to true.");
        //         } else {
        //             setIsAdmin(false);
        //             console.log("User is not Admin, setting isAdmin to false.");
        //         }
        //     } catch (error) {
        //         console.error("Error verifying token:", error);
        //         setIsAdmin(false);
        //     }
        // };

        // verifyToken(); // Call the function to verify the token

    //     return () => unsubscribe();
    // }, []);

    useEffect(() => {
        // Check the Firebase auth state for user information
        
          
            
            setUserEmail(email || '');
            setFormValues((prevValues) => ({
              ...prevValues,
              email: email || '',
            }));
      }, [email]);
    
      // Log the role and login status, based on props received from App.js
      useEffect(() => {
        console.log("Admin status:", isAdmin);
      }, [isAdmin]);


    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const snapshot = await getDocs(ref);
                const eventsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setEvents(eventsData);
            } catch (error) {
                console.error("Error fetching events: ", error);
            }
        };
        fetchEvents();
    }, []);

    const checkFormFilled = () => {
        const { username, mobno, email, eventName, startTime, endTime,hostedFor } = formValues;
        setFormFilled(username && mobno && email && eventName && startTime && endTime &&hostedFor);
    };

    const renderCalendar = () => {
        const calendarEvents = events.map(event => ({
            title: event.eventName,
            start: new Date(event.startTime),
            end: new Date(event.endTime),
            userConfirmed: event.userConfirmed,
            confirmed: event.confirmed,
        }));

        console.log("Calendar Events:", calendarEvents);

        const eventStyleGetter = (event) => {
            const backgroundColor = event.confirmed ? 'green' : '#3174ad';
            return { style: { backgroundColor } };
        };

        return (
            isAdmin && (
                <Calendar
                    localizer={localizer}
                    events={calendarEvents}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: 500, margin: '50px' }}
                    selectable
                    eventPropGetter={eventStyleGetter}
                    onSelectSlot={(slotInfo) => {
                        setFormValues(prevValues => ({
                            ...prevValues,
                            startTime: moment(slotInfo.start).format('YYYY-MM-DDTHH:mm'),
                            endTime: moment(slotInfo.end).format('YYYY-MM-DDTHH:mm'),
                        }));
                        setOpenDialog(true);
                    }}
                />
            )
        );
    };

    const addPost = async () => {
        try {
            const { repetition, ...restFormValues } = formValues;
            const userConfirmed = !isAdmin;
    
            // Helper function to add an event
            const addEvent = async (eventData) => {
                const newEvent = {
                    ...eventData,
                    userConfirmed,
                    confirmed: isAdmin, // Admin confirmation status
                };
                await addDoc(ref, newEvent);
                setEvents([...events, newEvent]);
            };
    
            // Helper function to adjust the date based on the repetition
            const adjustDate = (date, repetition) => {
                const newDate = new Date(date);
                switch (repetition) {
                    case 'Daily':
                        newDate.setDate(newDate.getDate() + 1);
                        break;
                    case 'Weekly':
                        newDate.setDate(newDate.getDate() + 7);
                        break;
                    case 'Monthly':
                        newDate.setMonth(newDate.getMonth() + 1);
                        break;
                    default:
                        break;
                }
                return newDate;
            };
    
            let currentStartDate = new Date(formValues.startTime);
            let currentEndDate = new Date(formValues.endTime);
            const repetitionLimit = 10; // Limit to prevent excessive event creation
    
            for (let i = 0; i < repetitionLimit; i++) {
                await addEvent({
                    ...restFormValues,
                    startTime: currentStartDate.toISOString(),
                    endTime: currentEndDate.toISOString(),
                });
    
                if (repetition === 'Does not repeat') break;
    
                currentStartDate = adjustDate(currentStartDate, repetition);
                currentEndDate = adjustDate(currentEndDate, repetition);
            }
    
            setOpenSnackbar(true);
            handleReset();
        } catch (err) {
            console.error(err);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        const newValue = type === 'checkbox' ? checked : value;
        setFormValues(prevValues => ({
            ...prevValues,
            [name]: newValue
        }));
        checkFormFilled();
    };

    const handleReset = () => {
        
        setFormValues({
            username: '',
            mobno: '',
            email: '',
            eventName: '',
            startTime: '',
            endTime: '',
            setReminder: false,
            thankYouNotification: false,
            visitCompleted: false,
            hostedFor: '',
            repetition: 'Does not repeat',
        });
        setFormFilled(false);
    };

    const isFormValid = () => {
        const { eventName, startTime, endTime } = formValues;
        return eventName && startTime && endTime;
    };

    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };


    const confirmAppointment = async (eventId) => {
        try {
            const eventDoc = doc(firestore, "appointment", eventId);
            
            // Update Firestore document to set confirmed status to true
            await updateDoc(eventDoc, { confirmed: true });
    
            // Retrieve event details
            const event = events.find(event => event.id === eventId);
            const phoneNumber = event.mobno.startsWith("+91") ? event.mobno : `+91${event.mobno}`;
            const eventName = event.eventName;
            const eventDate = moment(event.startTime).format("YYYY-MM-DD");
            const eventStartTime = moment(event.startTime).format("HH:mm");
            const username = event.username;
            const eventEndTime = moment(event.endTime).format("HH:mm");
    
            // Send WhatsApp message to confirm the appointment
            await sendAppointmentConfirmationWhatsApp(username,phoneNumber, eventName, eventDate, eventStartTime, eventEndTime);
    
            // Update local events state to reflect confirmation
            setEvents(prevEvents =>
                prevEvents.map(event =>
                    event.id === eventId ? { ...event, confirmed: true } : event
                )
            );
    
            console.log("Appointment confirmed and WhatsApp message sent.");
    
        } catch (error) {
            console.error("Error confirming appointment:", error);
        }
    };
    
    const sendAppointmentConfirmationWhatsApp = async (username,phoneNumber, eventName, eventDate, eventStartTime,eventEndTime) => {
        const accessToken = "EAAIMIuxpnPwBOw76q2LJ1EvQ4LwuZBAwh2VWhp5PbZAcgLterH9PdViwMO25E0ZBct3NWqKYOTuYBRycYNZChmEwTW1QOrHDVIWk19P6at1f3MTadE5ctixZC4WYFJwNowPtLZC2LgAEinhe9ZCsxDhbcL5P82sDu7lFnZC31hKoyIXX6YvWIFZC1Q6OUQBTpZB607mhcF1jINZBZAIDNV5Ncwim9bCqhAvs5rnV744ZD";// Replace with your actual access token
        const phoneNumberId = "442512678953158"; // Replace with your actual phone number ID
    
        // Prepare WhatsApp message payload
        const payload = {
            messaging_product: "whatsapp",
            to: phoneNumber,
            type: "template",
            template: {
                name: "retail", // Your approved WhatsApp template name
                language: { code: "en_US" },
                components: [
                    {
                        type: "body",
                        parameters: [
                            { type: "text", text: username },
                            { type: "text", text: eventName },
                            { type: "text", text: eventDate },
                            { type: "text", text: eventStartTime },
                            { type: "text", text: eventEndTime },
                        ]
                    }
                ]
            }
        };
    
        try {
            const response = await axios.post(
                `https://graph.facebook.com/v13.0/${phoneNumberId}/messages`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json"
                    }
                }
            );
    
            if (response.status === 200) {
                console.log("WhatsApp message sent successfully:", response.data);
            } else {
                console.error("Error in WhatsApp message response:", response.data);
            }
        } catch (error) {
            console.error("Error sending WhatsApp message:", error.response?.data || error.message);
        }
    };
    
    
    
    
    const rejectAppointment = async (eventId) => {
        try {
            const eventDoc = doc(firestore, "appointment", eventId);
            await deleteDoc(eventDoc);
            setEvents(prevEvents => 
                prevEvents.filter(event => event.id !== eventId)
            );
        } catch (error) {
            console.error("Error deleting appointment: ", error);
        }
    };

    const handleRowClick = (event) => {
        setSelectedEvent(event);
    };

    const handleEditClick = (event) => {
        setSelectedEvent(event);
        setNewEventName(event.eventName);
        setOpenEditDialog(true);
    };

    const handleUpdateEventName = async () => {
        if (selectedEvent) {
            const eventDoc = doc(firestore, "appointment", selectedEvent.id);
            try {
                await updateDoc(eventDoc, { eventName: newEventName });
                setEvents(events.map(event => event.id === selectedEvent.id ? { ...event, eventName: newEventName } : event));
                setOpenEditDialog(false);
            } catch (error) {
                console.error("Error updating event name: ", error);
            }
        }
    };


    const renderAdminControls = () => {
        const filteredEvents = events.filter(event => event.hostedFor === userEmail || event.email === userEmail); // Filter events
    
        return (
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Customer</TableCell>
                            <TableCell>Mobile</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Event Name</TableCell>
                            <TableCell>Start Time</TableCell>
                            <TableCell>End Time</TableCell>
                            <TableCell>Hosted For</TableCell>
                            <TableCell>User Confirmation</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredEvents.map(event => (
                            <TableRow key={event.id}>
                                <TableCell>{event.username}</TableCell>
                                <TableCell>{event.mobno}</TableCell>
                                <TableCell>{event.email}</TableCell>
                                <TableCell>{event.eventName}</TableCell>
                                <TableCell>{moment(event.startTime).format('MMMM Do YYYY, h:mm a')}</TableCell>
                                <TableCell>{moment(event.endTime).format('MMMM Do YYYY, h:mm a')}</TableCell>
                                <TableCell>{event.hostedFor}</TableCell>
                                <TableCell>{event.userConfirmed ? 'Confirmed' : 'Pending'}</TableCell>
                                <TableCell>
                                    <Button 
                                        variant="contained" 
                                        color="primary" 
                                        onClick={() => confirmAppointment(event.id)} 
                                        disabled={event.confirmed}
                                    >
                                        Accept
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        color="secondary" 
                                        onClick={() => rejectAppointment(event.id)}
                                    >
                                        Cancel
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        onClick={() => handleEditClick(event)}
                                    >
                                        Edit
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };
    const renderUserControls = () => {
        const filteredEvents = events.filter(event => event.hostedFor === userEmail || event.email === userEmail); // Filter events
    
        return (
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Customer</TableCell>
                            <TableCell>Mobile</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Event Name</TableCell>
                            <TableCell>Start Time</TableCell>
                            <TableCell>End Time</TableCell>
                            <TableCell>Admin Confirmation Status</TableCell> {/* New column */}
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredEvents.map(event => (
                            <TableRow key={event.id} onClick={() => handleRowClick(event)} selected={selectedEvent && selectedEvent.id === event.id}>
                                <TableCell>{event.username}</TableCell>
                                <TableCell>{event.mobno}</TableCell>
                                <TableCell>{event.hostedFor || event.email}</TableCell>
                                <TableCell>{event.eventName}</TableCell>
                                <TableCell>{moment(event.startTime).format('MMMM Do YYYY, h:mm a')}</TableCell>
                                <TableCell>{moment(event.endTime).format('MMMM Do YYYY, h:mm a')}</TableCell>
                                <TableCell>
                                    {event.confirmed ? 'Confirmed' : 'Pending'} {/* Admin confirmation status */}
                                </TableCell>
                                <TableCell>
                                    {(!isAdmin && event.hostedFor === userEmail) ? (
                                        <>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => confirmUserAppointment(event.id)}
                                                style={{ marginRight: '10px' }}
                                                disabled={event.userConfirmed}
                                            >
                                                Accept
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => rejectUserAppointment(event.id)}
                                            >
                                                Cancel
                                            </Button>
                                        </>
                                    ) : (!isAdmin && !event.userConfirmed) ? (
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => rejectUserAppointment(event.id)}
                                        >
                                            Cancel
                                        </Button>
                                    ) : (!isAdmin && event.userConfirmed) ? (  // Allow user to reject after confirming
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => rejectUserAppointment(event.id)}
                                        >
                                            Cancel
                                        </Button>
                                    ) : null}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };


    

 
    const confirmUserAppointment = async (eventId) => {
        try {
            const eventDoc = doc(firestore, "appointment", eventId);
            await updateDoc(eventDoc, { userConfirmed: true });
            setEvents(events.map(event => 
                event.id === eventId 
                ? { ...event, userConfirmed: true } 
                : event
            ));
        } catch (error) {
            console.error("Error confirming appointment: ", error);
        }
    };
    
    const rejectUserAppointment = async (eventId) => {
        try {
            const eventDoc = doc(firestore, "appointment", eventId);
            await deleteDoc(eventDoc);  // Delete the document from Firestore
            setEvents(events.filter(event => event.id !== eventId));  // Update the local state to remove the event
        } catch (error) {
            console.error("Error rejecting appointment: ", error);
        }
    };
    const sendOrderErrorEmail = async (email, apiKey, orderId, errorMessage) => {
        const jsonPayload = {
            email,
            subject: `Order Confirmation Error - ${orderId}`,
            textbody: `We encountered an error while processing your order with ID ${orderId}.`,
            htmlbody: 
                `<div style="font-family: Arial, sans-serif; color: #333;">
                    <h2 style="color: #f44336;">Order Confirmation Error</h2>
                    <p>We encountered an error while processing your order with ID <strong>${orderId}</strong>.</p>
                    <p>Error Details: ${errorMessage}</p>
                    <p>Please contact our support team for assistance.</p>
                </div>`,
            apiKey,
        };
    
        const formData = new FormData();
        formData.append('jsonPayload', JSON.stringify(jsonPayload));
    
        try {
            const response = await axios.post('https://email-a306.onrender.com/send-email', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
    
            if (response.status === 200) {
                return 'Error email sent successfully!';
            } else {
                return 'Error sending error email.';
            }
        } catch (error) {
            if (error.response && error.response.status === 403) {
                return 'Invalid API key';
            } else {
                return 'Error sending error email.';
            }
        }
    };
    
    const sendOrderConfirmationEmail = async (email, apiKey, orderId, eventName, eventDate, eventTime) => {
        const jsonPayload = {
            email,
            subject: `Order Confirmation - ${orderId}`,
            textbody: `Thank you for your order. Your order ID is ${orderId}.`,
            htmlbody: 
                `<div style="font-family: Arial, sans-serif; color: #333;">
                    <h2 style="color: #4CAF50;">Thank you for your order!</h2>
                    <p>Your order ID is <strong>${orderId}</strong>.</p>
                    <h3>Event Details:</h3>
                    <p><strong>Event Name:</strong> ${eventName}</p>
                    <p><strong>Date:</strong> ${eventDate}</p>
                    <p><strong>Time:</strong> ${eventTime}</p>
                </div>`,
            apiKey,
        };
    
        const formData = new FormData();
        formData.append('jsonPayload', JSON.stringify(jsonPayload));
    
        try {
            const response = await axios.post('https://email-a306.onrender.com/send-email', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
    
            if (response.status === 200) {
                return 'Email sent successfully!';
            } else {
                await sendOrderErrorEmail(email, apiKey, orderId, 'Error sending confirmation email');
                return 'Error sending email.';
            }
        } catch (error) {
            if (error.response && error.response.status === 403) {
                await sendOrderErrorEmail(email, apiKey, orderId, 'Invalid API key');
                return 'Invalid API key';
            } else {
                await sendOrderErrorEmail(email, apiKey, orderId, 'Error sending confirmation email');
                return 'Error sending email.';
            }
        }
    };

    return (
        <Container maxWidth="md" sx={{ padding: '20px' }} >
          <form onSubmit={(e) => { e.preventDefault(); addPost(); }}>
          <Grid container spacing={3} >
          <Grid item xs={12} >
            <TextField
              
              required
              label="Username"
              name="username"
              value={formValues.username}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              className="textField"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              label="Mobile Number"
              name="mobno"
              value={formValues.mobno}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              className="textField"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              label="Email"
              name="email"
              value={formValues.email}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              className="textField"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              label="Event Name"
              name="eventName"
              value={formValues.eventName}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              className="textField"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              label="Start Time"
              name="startTime"
              type="datetime-local"
              value={formValues.startTime}
              onChange={handleInputChange}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              className="textField"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              label="End Time"
              name="endTime"
              type="datetime-local"
              value={formValues.endTime}
              onChange={handleInputChange}
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              className="textField"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              label="Invitee Email"
              name="hostedFor"
              value={formValues.hostedFor}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              className="textField"
            />
          </Grid>
          {isAdmin && <Grid item xs={12}>
            <Select
              name="repetition"
              value={formValues.repetition}
              onChange={handleInputChange}
              fullWidth
              className="textField"
            >
              <MenuItem value="Does not repeat">Does not repeat</MenuItem>
              <MenuItem value="Daily">Daily</MenuItem>
              <MenuItem value="Weekly">Weekly</MenuItem>
              <MenuItem value="Monthly">Monthly</MenuItem>
            </Select>
          </Grid>}
          <Grid container spacing={2} item xs={12}>
  <Grid item xs={6}> {/* Adjust the size as needed */}
    <Button 
      fullWidth 
      type="submit" 
      variant="contained" 
      color="primary" 
      sx={{ backgroundColor: 'green', '&:hover': { backgroundColor: 'darkgreen' } }}
    >
      Submit
    </Button>
  </Grid>
  <Grid item xs={6}> {/* Adjust the size as needed */}
    <Button 
      fullWidth 
      variant="contained" 
      onClick={handleReset} 
      sx={{ mb: 5 }}
    >
      Reset
    </Button>
  </Grid>
</Grid>

        </Grid>
          </form>
          <Snackbar
            open={openSnackbar}
            autoHideDuration={6000}
            onClose={handleSnackbarClose}
            message="Appointment added successfully"
          />
    
          {isAdmin && renderCalendar()}
          {isAdmin ? renderAdminControls() : renderUserControls()}
    
          <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)}>
            <DialogTitle>Edit Event Name</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Update the name of the event.
              </DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                label="Event Name"
                type="text"
                fullWidth
                value={newEventName}
                onChange={(e) => setNewEventName(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenEditDialog(false)} color="primary">Cancel</Button>
              <Button onClick={handleUpdateEventName} color="primary">Update</Button>
            </DialogActions>
          </Dialog>
        </Container>
      );
    };

export default Appointment;

// I have collection in firebase:
// confirmed
// true
// (boolean)

// email
// "gayatrisbadgujar1606@gmail.com"
// (string)

// endTime
// "2024-08-10T12:14:00.000Z"
// (string)

// eventName
// "test"
// (string)

// hostedFor
// "1032210525@mitwpu.edu.in"
// (string)

// mobno
// "9922404444"
// (string)

// setReminder
// false
// (boolean)

// startTime
// "2024-08-21T09:14:00.000Z"
// (string)

// thankYouNotification
// false
// (boolean)

// userConfirmed
// false
// (boolean)

// username
// "GAYATRI BADGUJAR"
// (string)

// visitCompleted
// false

// I want only those appointment visible to logged in user whose email id matches with email field in collection